import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';
import OtherPages from '../views/OtherPages.vue';

const ifAuthenticated = (to, from, next) => {
  if (store.getters['context/isAuthenticated']) {
    next();
    return;
  }
  next({ name: 'Login' });
};

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['context/isAuthenticated']) {
    next();
    return;
  }
  next({ name: 'Home' });
};

const routes = [{
  path: '/arinet/',
  name: 'OtherPages',
  component: OtherPages,
  children: [{
    path: 'about',
    name: 'About',
    component: () => import('../components/About/About.vue')
    // props: true,
  },
  {
    path: 'support',
    name: 'Support',
    component: () => import('../components/Support/SupportPage.vue')
  }
  ]
},
{
  path: '/',
  name: 'Home',
  component: Home,
  beforeEnter: ifAuthenticated,
  children: [{
    path: 'search',
    name: 'Search',
    component: () => import('../components/Search/SearchPeople.vue'),
    props: true
  },
  {
    path: 'friends',
    name: 'Friends',
    component: () => import('../components/Friends/FriendsPage.vue'),
    props: route => ({
      openRequests: route.query.openRequests,
      userId: route.query.userId,
      page: route.query.page
    })
  },
  {
    path: 'album/:albumId',
    name: 'Album',
    props: true,
    component: () => import('../components/Photo/EditAlbumView.vue')
  },
  {
    path: 'photo',
    name: 'Photo',
    component: () => import('../components/Photo/Photos.vue'),
    props: route => ({
      userId: route.query.userId,
      albumsId: route.query.albumsId
    })
  },
  {
    path: 'createPhoto/:newPhotos',
    name: 'CreatePhoto',
    props: true,
    component: () => import('../components/Photo/addPhoto.vue')
  },
  {
    path: 'createAlbum',
    name: 'CreateAlbum',
    component: () => import('../components/Photo/albumCreate.vue')
  },
  {
    path: 'create-group',
    name: 'CreateGroup',
    component: () => import('../components/groups/CreateGroup.vue')
  },
  {
    path: 'edit-group/:id',
    name: 'EditGroup',
    component: () => import('../components/groups/CreateGroup.vue')
  },
  {
    path: 'members-search/:id',
    name: 'MemberSearch',
    component: () => import('../components/groups/GroupMembersSearch.vue'),
    props: true
  },
  {
    path: 'group/:id',
    name: 'Group',
    component: () => import('../components/groups/Group.vue'),
    props: true
  },
  {
    path: 'groups',
    name: 'Groups',
    component: () => import('../components/groups/Groups.vue'),
    props: route => ({
      userId: route.query.userId
    }),
    children: [{
      path: ':type',
      name: 'GroupsList',
      component: () => import('../components/groups/GroupList.vue'),
      props: true
    }]
  },
  {
    path: '',
    name: 'News',
    component: () => import('../components/News/News.vue')
  },
  {
    path: 'manage-group/:id',
    name: 'ManageGroup',
    component: () => import('../components/groups/ManageGroup.vue'),
    props: true
  },
  {
    path: 'group-members/:id',
    name: 'GroupMembers',
    component: () => import('../components/groups/GroupMembersReadOnly.vue'),
    props: true
  },
  {
    path: 'search-groups',
    name: 'SearchGroups',
    component: () => import('../components/groups/SearchGroups.vue'),
    props: true
  },
  {
    path: 'editProfile',
    name: 'EditProfile',
    component: () => import('../components/EditProfile/EditProfile.vue')
  },
  {
    path: 'notifyList',
    name: 'NotifyList',
    component: () => import('../components/Notifications/notifyList.vue')
  },
  {
    path: 'Profile/:id',
    name: 'Profile',
    props: true,
    component: () => import('../components/Profile/ProfileView.vue')
  },
  {
    path: '/chats',
    name: 'Chats',
    component: () => import('../components/chats/Conversations.vue'),
    children: [{
      path: '',
      name: 'ChatsRoot',
      component: () => import('../components/chats/EmptyChat.vue')
    },
    {
      path: 'conversation',
      name: 'Conversation',
      component: () => import('../components/chats/Conversation.vue'),
      props: route => ({
        userId: route.query.userId,
        chatId: route.query.chatId,
        messageId: route.query.messageId,
        openCall: route.query.openCall
      })
    },
    {
      path: 'newChat',
      name: 'NewChat',
      component: () => import('../components/chats/NewChat')
    }
    ]
  },
  {
    path: 'broadcast/:id',
    name: 'Broadcast',
    component: () => import('../components/Broadcasts/manipulatorBroadcast.vue'),
    props: true
  },
  {
    path: 'active-broadcasts',
    name: 'ActiveBroadcasts',
    component: () => import('../components/Broadcasts/activeBroadcasts.vue')
  },
  {
    path: 'manipulators',
    name: 'Manipulators',
    component: () => import('../components/manipulators/manipulatorsHome.vue'),
    children: [{
      path: 'rent/:id',
      name: 'ManipulatorRent',
      component: () => import('../components/manipulators/manipulatorRent.vue'),
      props: true
    },
    {
      path: 'rent-ready/:id',
      name: 'ManipulatorRentReady',
      props: true,
      component: () => import('../components/manipulators/manipulatorRentReady.vue')
    },
    {
      path: 'purchase/:id',
      name: 'ManipulatorPurchase',
      component: () => import('../components/manipulators/manipulatorPurchase.vue')
    },
    {
      path: 'reg-training/:id',
      name: 'ManipulatorRegTraining',
      component: () => import('../components/manipulators/manipulatorRegTraining.vue')
    },
    {
      path: 'catalog',
      name: 'ManipulatorsCatalog',
      component: () => import('../components/manipulators/manipulatorsCatalog.vue')
    },
    {
      path: 'adding-ad',
      name: 'ManipulatorsAddingAd',
      component: () => import('../components/manipulators/manipulatorAddingAd.vue')
    },
    {
      path: 'my-ad',
      name: 'ManipulatorMyAd',
      component: () => import('../components/manipulators/manipulatorMyAd.vue')
    },
    {
      path: 'editing-ad/:id',
      name: 'ManipulatorsEditingAd',
      component: () => import('../components/manipulators/manipulatorEditingAd'),
      props: true
    },
    {
      path: '',
      name: 'ManipulatorsList',
      component: () => import('../components/manipulators/manipulatorsList.vue')
    },
    {
      path: 'admin-orders',
      name: 'ManipulatorAdminOrders',
      component: () => import('../components/manipulators/manipulatorAdminOrders.vue')
    },
    {
      path: 'users-orders',
      name: 'MarketplaceUsersOrders',
      component: () => import('../components/manipulators/marketplaceUsersOrders.vue')
    }, {
      path: 'info/:id',
      name: 'ManipulatorInfo',
      component: () => import('../components/manipulators/manipulatorInfo.vue'),
      props: true,
      children: [{
        path: 'description',
        name: 'ManipulatorDesciption',
        component: () => import('../components/manipulators/manipulatorInfoDescription.vue'),
        props: true
      },
      {
        path: 'news',
        name: 'ManipulatorNews',
        component: () => import('../components/manipulators/manipulatorInfoNews.vue'),
        props: true
      },
      {
        path: 'participant',
        name: 'ManipulatorsParticipant',
        component: () => import('../components/manipulators/manipulatorsMembersPage'),
        props: true
      }
      ]
    },
    {
      path: 'edit/:id',
      name: 'ManipulatorsEdit',
      component: () => import('../components/manipulators/manipulatorsEditPage.vue'),
      props: true
    },
    {
      path: 'adding',
      name: 'ManipulatorAdding',
      component: () => import('../components/manipulators/manipulatorAdding.vue')
    }
    ]
  },
  {
    path: 'attachment',
    name: 'Attachment',
    component: () => import('../components/Attachment/Attachment.vue')
  }
  ]
},
{
  path: '/confirmation/',
  name: 'Confirmation',
  component: () => import('../components/Account/Authorization.vue'),
  children: [{
    path: 'phone',
    name: 'ConfirmationPhone',
    component: () => import('../components/Account/ConfirmationPhone.vue'),
    props: true
  },
  {
    path: 'email',
    name: 'ConfirmationEmail',
    component: () => import('../components/Account/ConfirmationEmail.vue')
  }
  ]
}, {
  path: '/recovery/',
  name: 'Recovery',
  component: () => import('../components/Account/Authorization.vue'),
  children: [{
    path: '',
    name: 'RecoveryKey',
    component: () => import('../components/Recovery/RecoveryKey.vue')
  },
  {
    path: 'sms',
    name: 'RecoveryConfirmationSms',
    component: () => import('../components/Recovery/ConfirmationSms.vue'),
    props: true
  },
  {
    path: 'email',
    name: 'RecoveryConfirmationEmail',
    component: () => import('../components/Recovery/ConfirmationEmail.vue'),
    props: true
  },
  {
    path: 'password',
    name: 'RecoveryPassword',
    component: () => import('../components/Recovery/RecoveryPassword.vue')
  }
  ]
}, {
  path: '/account',
  name: 'Account',
  component: () => import('../components/Account/Authorization.vue'),
  children: [{
    path: 'phone',
    name: 'AccountPhone',
    component: () => import('../components/Account/Phone.vue'),
    props: true
  }]
}, {
  path: '/authorization',
  name: 'Authorization',
  component: () => import('../components/Account/Authorization.vue'),
  beforeEnter: ifNotAuthenticated,
  children: [{
    path: '',
    name: 'Login',
    component: () => import('../components/Account/Login.vue'),
    props: route => ({
      reg: route.query.reg,
      fogot: route.query.fogot,
      reset: route.query.reset,
      phoneConfirmed: route.query.phoneConfirmed,
      phoneEntered: route.query.phoneEntered
    })
  },
  {
    path: 'registration',
    name: 'Registration',
    component: () => import('../components/Account/Registration.vue')
  }
  ]
}
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
